import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function SignOut(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18"
  }, props), React.createElement("path", {
    d: "M7.168.313a.75.75 0 100 1.5h11.145v14.359H7.168a.75.75 0 000 1.5h11.395c.69 0 1.25-.56 1.25-1.25V1.562c0-.69-.56-1.25-1.25-1.25H7.168zm-1.473 13.45a.75.75 0 01-1.06.015L.415 9.672a.75.75 0 01-.018-1.057l4.22-4.39a.75.75 0 011.081 1.039L2.621 8.466h11.91a.75.75 0 010 1.5H2.868l2.813 2.737a.75.75 0 01.014 1.06z"
  }));
}

export { SignOut };
//# sourceMappingURL=SignOut.js.map